import React, { lazy, Suspense} from "react";

import DefaultLoader from "../utilities/loaders/DefaultLoader";
const PaymentsContent = lazy(() => import('./PaymentsContent'));



const Payments = () => {
    return (
        <Suspense fallback={<DefaultLoader />}>
            <PaymentsContent />
        </Suspense>
    );
};

export default Payments;